'use client';

import { cn } from '@/lib/utils';
import { useSpring, a } from '@react-spring/web';
import Link from 'next/link';
import { useState } from 'react';

export default function SeeMore({ title }: { title: string }) {
  const [hovered, setHovered] = useState(false);

  const cardStyle = useSpring({
    borderWidth: hovered ? 3 : 1,
    padding: hovered ? '10px 18px' : '11px 19px',
    config: { tension: 170, friction: 26 },
  });

  const textStyle = useSpring({
    fontSize: hovered ? '16px' : '14px',
    config: { tension: 170, friction: 20 },
  });

  return (
    <Link
      href={'/portfolio'}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <a.div
        style={cardStyle}
        className={cn(
          'w-full h-full text-[#F2F2F2] flex justify-center items-center rounded-3xl border border-[#F2F2F2]'
        )}
      >
        <a.p
          style={textStyle}
          className='text-[14px] leading-none tracking-[-0.05em] uppercase'
        >
          {title}
        </a.p>
      </a.div>
    </Link>
  );
}
